import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import { getUtmTypeformUrl } from '@lib/searchQuery';
import Page from '@components/Page';

export default function QuizTemplate({
  pageContext: { language, configuration: { typeforms }},
  location
}) {
  return (
    <Page>
      <Helmet>
        <style type="text/css">
          {`
            html { margin: 0; height: 100%; overflow: hidden; }
            iframe { position: absolute; left:0; right:0; bottom:0; top:0; border:0; }
          `}
        </style>
        <script type="text/javascript" src="https://embed.typeform.com/embed.js"></script>
      </Helmet>
      <iframe
        id="typeform-full"
        width="100%"
        height="100%"
        frameBorder="0"
        allow="camera; microphone; autoplay; encrypted-media;"
        src={getUtmTypeformUrl({ type: 'quiz', location, language, typeforms })}
      />
    </Page>
  );
}

export const query = graphql`
  query($id: Int) {
    page: wordpressWpWebsites(wordpress_id: { eq: $id }) {
      ...Page
    }
  }
`;